import {
  AllCollectionsIcon,
  AllCollectionsActiveIcon,
  CoursesIcon,
  CoursesActiveIcon,
  EssentialsCategoryIcon,
  EssentialsCategoryIconThinActive,
  FreeGiftActiveIcon,
  LiveIcon,
  LiveActiveIcon,
  TutorialsIcon,
  TutorialsActiveIcon,
  CourseVideoIcon,
  PFLIcon
} from "../../../../modules/Icons"

const outlinedIconClass = "inline w-5 mr-[15px] stroke-inherit"
const filledIconClass = "inline w-5 mr-[15px] fill-inherit"

const AcademyTopLevelLinkConfig = [
  {
    text: "Academy Home",
    href: "/academy",
    icon: <AllCollectionsIcon className={outlinedIconClass} />,
    selectedIcon: <AllCollectionsActiveIcon className="inline mr-[15px] stroke-none" />,
    selected: false
  },
  {
    text: "Courses",
    href: "/academy/courses",
    icon: <CoursesIcon className={outlinedIconClass} />,
    selectedIcon: <CoursesActiveIcon className="inline mr-[15px] fill-inherit stroke-none" />,
    selected: false
  },
  {
    text: "Tutorials",
    href: "/academy/tutorials",
    icon: <TutorialsIcon className={filledIconClass} />,
    selectedIcon: <TutorialsActiveIcon className="inline mr-[15px] stroke-none fill-inherit" />,
    selected: false
  },
  // Coming Soon!
  // {
  //   text: "Live",
  //   href: "/academy/live",
  //   icon: <LiveIcon className={outlinedIconClass} />,
  //   selectedIcon: <LiveActiveIcon className="inline mr-[15px] stroke-inherit" />,
  //   selected: false
  // },
  // {
  //   text: "Essentials",
  //   href: "/academy/essentials",
  //   icon: <EssentialsCategoryIcon className={outlinedIconClass} />,
  //   selectedIcon: <EssentialsCategoryIconThinActive className="inline mr-[15px] stroke-none" />,
  //   selected: false
  // },
  {
    text: "Practice Footage",
    href: "/practice-footage",
    icon: <PFLIcon className={outlinedIconClass} />,
    selectedIcon: <FreeGiftActiveIcon className='inline mr-[15px] stroke-none' />,
    selected: false
  },
]

export default AcademyTopLevelLinkConfig;